<app-loading *ngIf="isLoading$ | async"></app-loading> <router-outlet></router-outlet>
